var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsersActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 7.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Zm2.5 9c0 1.933-2.686 3.5-6 3.5s-6-1.567-6-3.5S8.686 13 12 13s6 1.567 6 3.5ZM7.122 5c.178 0 .35.017.518.05A4.977 4.977 0 0 0 7 7.5c0 .868.221 1.685.61 2.396-.158.03-.32.045-.488.045-1.414 0-2.561-1.106-2.561-2.47C4.561 6.106 5.708 5 7.122 5ZM5.447 18.986C4.88 18.307 4.5 17.474 4.5 16.5c0-.944.357-1.756.896-2.423C3.49 14.225 2 15.267 2 16.529c0 1.275 1.517 2.325 3.447 2.457ZM17 7.5c0 .868-.221 1.685-.61 2.396.157.03.32.045.488.045 1.414 0 2.56-1.106 2.56-2.47 0-1.365-1.146-2.471-2.56-2.471-.178 0-.35.017-.518.05.407.724.64 1.56.64 2.45Zm1.553 11.486c1.93-.132 3.447-1.182 3.447-2.457 0-1.263-1.491-2.304-3.396-2.452.54.667.896 1.479.896 2.423 0 .974-.38 1.807-.947 2.486Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersActive);
export default __webpack_public_path__ + "static/media/UsersActive.e6859ae803f4affb4f6521658c18d7fe.svg";
export { ForwardRef as ReactComponent };